export default __webpack_public_path__ + "static/media/Grupo 158.76dd23db.svg";